import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const MediaMentionsDesktop = loadable(() => import("./Desktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <MediaMentionsDesktop {...props} />
  </ErrorBoundary>
);
